import React from 'react'
import PropTypes from 'prop-types'
import Layout from '@layouts/Layout'
import { useIntl } from 'gatsby-plugin-intl'
import { Section1 } from '@templates/store'
import Jumbotron from '@components/jumbotron/Jumbotron'
import { faStore } from '@fortawesome/free-solid-svg-icons'

const Store = props => {
  const { formatMessage } = useIntl()
  const { pageContext } = props
  const { languageName } = pageContext

  return <Layout languageName={languageName} pageContext={pageContext}>
    <Jumbotron
      icon={faStore}
      title={formatMessage({ id: 'menu-store' })}
      description={formatMessage({ id: 'menu-store-content' })}
    />
    <div className='row'>
      <Section1 className='col-md-12'>
        Store
      </Section1>
    </div>
  </Layout>
}

Store.propTypes = {
  pageContext: PropTypes.any
}

export default Store
